//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LookingFor',
  data() {
    return {
      imgUrl: 'https://static.moele.me/img/signup/contributors/contributor-signup-mediatypes.221031.svg',
    };
  },
};
